/**
 * BE が返す JST の 'yyyyMMddHHmmss' 形式文字列（例: "20260731200000"）を Date に変換する。
 * Date.UTC は時刻の桁あふれ（例: hour = 20 - 9）を自動で繰り上げ/繰り下げ処理する。
 */
export const parseJstDateTime = (jst: string): Date => {
  const year = Number(jst.slice(0, 4));
  const month = Number(jst.slice(4, 6));
  const day = Number(jst.slice(6, 8));
  const hour = Number(jst.slice(8, 10));
  const minute = Number(jst.slice(10, 12));
  const second = Number(jst.slice(12, 14));

  return new Date(Date.UTC(year, month - 1, day, hour - 9, minute, second));
};

/**
 * 日本時間（JST = UTC+9）での現在日付を 'YYYY-MM-DD' 形式で返す。
 */
export const getCurrentDateInJapan = (): string => {
  const now = new Date();
  // JST は UTC+9 なので 9時間分のミリ秒を加算する
  const jstDate = new Date(now.getTime() + 9 * 60 * 60 * 1000);

  const year = jstDate.getUTCFullYear();
  const month = String(jstDate.getUTCMonth() + 1).padStart(2, "0");
  const day = String(jstDate.getUTCDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
